const TOAST_TARGET = "layout";

let started = false;
let toastVisible = false;
let lastKind = null;

function dispatch(name, params = {}) {
  if (typeof globalThis.Hologram?.dispatchAction === "function") {
    globalThis.Hologram.dispatchAction(name, TOAST_TARGET, params);
  }
}

function notify(kind, message) {
  if (toastVisible && lastKind === kind) return;
  lastKind = kind;
  toastVisible = true;
  dispatch("connection_issue", {kind, message});
}

function clearToast() {
  lastKind = null;
  if (!toastVisible) return;
  toastVisible = false;
  dispatch("connection_ok", {});
}

function requestMessage() {
  if (!navigator.onLine) {
    return "Geen internetverbinding. Je actie is mogelijk niet opgeslagen.";
  }

  return "Er ging iets mis bij het laden of opslaan. Controleer je verbinding en probeer opnieuw.";
}

function onOnline() {
  clearToast();
}

function onUnhandledRejection(event) {
  const message = String(event?.reason?.message || event?.reason || "");

  if (
    !message.includes("command failed") &&
    !message.includes("page fetch failed") &&
    !message.includes("Failed to fetch")
  ) {
    return;
  }

  notify("error", requestMessage());
}

export function resetConnectionToastKind() {
  lastKind = null;
  toastVisible = false;
}

export function startConnectionMonitor() {
  if (started || typeof window === "undefined") return;
  started = true;

  window.addEventListener("online", onOnline);
  window.addEventListener("unhandledrejection", onUnhandledRejection);
}
